// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__weO_V","inner":"Popup_inner__3mTPf"};